const mailSubject = "Welcome to the program. Let's get started!";
const reminderMailSubject = 'Annual checkup appointment reminder';
const defaultPrivacyPolicyLink = '[PRIVACY POLICY LINK]';
const defaultOptOutText = '[OPT OUT TEXT]';
const defaultOptOutLink = '[OPT OUT LINK]';

const generateInviteEmailSubject = () => encodeURI(mailSubject);

const generateInviteEmailBody = (org, encode = true) => {
  const privacyPolicyLink = org.privacy_policy_link
    ? org.privacy_policy_link
    : defaultPrivacyPolicyLink;
  const optOutText = org.general_opt_out_text ? org.general_opt_out_text : defaultOptOutText;
  const optOutLink = org.general_opt_out_link ? org.general_opt_out_link : defaultOptOutLink;

  const body = `Hi [CLIENT NAME]!

  Welcome to the Experience Solensia™ (frunevetmab injection) Program!

  In this program, we'll work together to control your cat's osteoarthritis (OA) pain. Sharing videos of your cat doing specific activities will help us observe changes in your cat's OA pain. 

  To get started, please visit https://experience-solensia.zoetispetcare.com?clinic_id=${org.id}. Here, you'll be able to sign in and create your account.
  
  Before your cat's first Solensia treatment, we'll need a set of baseline videos of your cat doing different actions. This is because OA pain most often shows in how cats perform 7 behaviors. Please take videos of your cat doing as many of these actions that are part of their everyday routine:
  
  •   Jumping up or down (eg, from a chair or table)
  •   Climbing up or down a step
  •   Walking
  •   Running
  •   Chasing
  
  These videos will be used to help us decide which activity is the best one for you to focus on throughout the program.
  
  If you have any questions, please don't hesitate to contact us.
  
  Thank you again for your partnership!

  ${org.name}
  ${org.address_1}
  ${org.city.name}, ${org.state.abbreviation} ${org.zipcode}

  Privacy Policy: ${privacyPolicyLink}

  ${optOutText}: ${optOutLink}`;

  return encode ? encodeURIComponent(body) : body;
};

const generateReminderEmailSubject = () => encodeURI(reminderMailSubject);

const generateReminderEmailBody = (org, encode = true) => {
  const privacyPolicyLink = org.privacy_policy_link
    ? org.privacy_policy_link
    : defaultPrivacyPolicyLink;
  const optOutText = org.general_opt_out_text ? org.general_opt_out_text : defaultOptOutText;
  const optOutLink = org.general_opt_out_link ? org.general_opt_out_link : defaultOptOutLink;

  const body = `Hi [CLIENT NAME]!

  The time has come for [Cat's Name]'s annual checkup appointment.  Please be sure to capture behavior videos of [Cat's Name] doing some of the below behaviors in order to help us gauge progress prior to your appoitnment.
  
  •   Jumping up or down (eg, from a chair or table)
  •   Climbing up or down a step
  •   Walking
  •   Running
  •   Chasing
  
  If you have any questions, please don't hesitate to contact us.
  
  Thank you again for your partnership!

  ${org.name}
  ${org.address_1}
  ${org.city.name}, ${org.state.abbreviation} ${org.zipcode}

  Privacy Policy: ${privacyPolicyLink}

  ${optOutText}: ${optOutLink}`;

  return encode ? encodeURIComponent(body) : body;
};

export {
  generateInviteEmailSubject,
  generateInviteEmailBody,
  generateReminderEmailSubject,
  generateReminderEmailBody,
};
